





























import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

const AuthModule = namespace('app/auth');

@Component
export default class NotFoundImpl extends Vue {
  @AuthModule.Getter('IsAuth')
  private readonly IsAuth!: boolean;

  private get DestinationRoute(): string {
    return this.IsAuth ? 'dashboard.events' : 'login';
  }
}
